// extracted by mini-css-extract-plugin
export default {"item":"CardVideo_item__OwF6f","video":"CardVideo_video__xwAHn"};